import { Component, h, OmiProps, tag, VNode } from "omi";

import { IconDefV1, IconDefV2, IconName, IconNameV1, IconNameV2 } from "./icons";
import styles from "./style.css?inline";

type Props = {
  name: IconName;
  width?: number;
  height?: number;
};

@tag("nw-icon")
export class NWIcon extends Component<Props> {
  static css = [styles];

  static propTypes = {
    name: String,
    width: Number,
    height: Number,
  };

  private isV2Icon(iconDef: { [name in IconNameV2]: VNode }, name: IconNameV1 | IconNameV2): name is IconNameV2 {
    return Object.keys(iconDef).includes(name);
  }

  render(props: OmiProps<Props>) {
    const { name } = this.props;

    if (!name) return null;

    const width = props.width ?? 16;
    const height = props.height ?? 16;

    const iconDef = IconDefV2(width, height);
    if (this.isV2Icon(iconDef, name)) {
      return iconDef[name];
    }

    // TODO migrate all existing icons to V2
    const { src, alt } = IconDefV1[name];
    return <img src={src} alt={alt} width={props.width ?? 16} height={props.height ?? 16} />;
  }
}

export * from "./icons.ts";
